// Copyright (c) Docugami, Inc. All rights reserved.

import { skipToken } from "@reduxjs/toolkit/dist/query";
import { useDocumentDgmlContext, DocumentDgmlContext } from "hooks/documentDgml";
import { useAppDispatch } from "hooks/redux";
import { useEffect } from "react";
import { useGetLabelsQuery } from "store/frontend/frontendSlice";
import { setCurrentDocument } from "store/sdvSlice";

export interface SdvContextProps {
    clusterId?: string;
    documentId?: string;
}

export function withSdvContext<T extends SdvContextProps>(WrappedComponent: React.ComponentType<T>) {
    return (props: T) => (
        <SdvContext {...props} >
            <WrappedComponent {...props} />
        </SdvContext>
    )
}

interface WithSdvContextProps extends SdvContextProps {
    children: React.ReactNode;
}

const SdvContext = (props: WithSdvContextProps) => {
    useGetLabelsQuery(props.clusterId ?? skipToken);
    const { clusterId, documentId } = props;
    const dispatch = useAppDispatch();

    useEffect(() => {
        dispatch(setCurrentDocument(documentId))
    }, [documentId, dispatch]);

    const dgmlContext = useDocumentDgmlContext(documentId ?? '');

    let node: JSX.Element = <></>;
    if (documentId !== undefined) {
        node = (
            <DocumentDgmlContext.Provider value={dgmlContext}>
                {props.children}
            </DocumentDgmlContext.Provider>
        )
    }

    if (clusterId !== undefined) {
        node = node || props.children;
    }

    return node;
}
